import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { resetUploadStatus, getSingleUploadedFile, createFilesUpload } from "../redux/slice/filesUploadSlice";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";

export const useDocumentUpload = ({ candidateId }) => {
    const dispatch = useDispatch();
    const { clearErrors, trigger } = useForm();
    const [selectedFiles, setSelectedFiles] = useState({});
    const { uploadStatus } = useSelector((state) => state.filesUpload);

    const handleFileSelect = (type, file) => {
        setSelectedFiles((prev) => ({
            ...prev,
            [type]: file
        }));
        if (file) {
            clearErrors(type)
        }
        dispatch(resetUploadStatus(type));
    }

    const handleFileUpload = async (type, fileFromArg) => {
        const file = fileFromArg || selectedFiles[type];
        if (!file) return;
        try {
            const formData = new FormData();
            formData.append("file", file);
            formData.append("type", type);
            formData.append("id", String(candidateId));

            await dispatch(createFilesUpload(formData)).unwrap();
            toast.success(`${type} uploaded successfully!`, {
                className: "toast-success-custom",
            });
            clearErrors(type);
            trigger(type);
        } catch (err) {
            toast.error(err?.message || `Failed in uploading ${type}!`, { className: 'toast-error-custom', autoClose: 5000 });
        }
    };


    const handleViewFile = async (type) => {
        try {
            const result = await dispatch(
                getSingleUploadedFile({
                    type,
                    id: candidateId,
                })
            ).unwrap();
            if (!result?.fileUrl) {
                alert("Error: The API returned a success, but the fileUrl is missing or empty!");
                return;
            }
            globalThis.open(result.fileUrl, "_blank", "noopener,noreferrer");
        } catch (err) {
            toast.error("Error viewing file:", err);
        }
    };


    const resetAllUploads = () => {
        setSelectedFiles({});
        dispatch(resetUploadStatus());
    }

    return {
        selectedFiles,
        uploadStatus,
        handleFileSelect,
        handleFileUpload,
        handleViewFile,
        resetAllUploads,
    };

};